import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box, Button} from 'views/components';
import {Tooltip, IconButton, Zoom} from 'views/components';
import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {ContentCopy as ContentCopyIcon, Delete as DeleteIcon} from 'views/icons';
import {translate, Translate} from 'views/module';

const ClientContact = (props) => {
  const [isHovering, setIsHovering] = React.useState(false);
  const [copyButton, setCopyButton] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);

  const {
    contact,
    clientBackend,
  } = props;


  const copyComment = () => {
    setCopyButton(true);
    return window.navigator.clipboard.writeText(contact.detail);
  };

  const deleteContact = () => {
    clientBackend.detail.removeContact(contact.type, () => {
      setIsDeleting(false);
    });
  };

  return (
    <Stack
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      direction={'row'}
      justifyContent="space-between"
    >
      <Stack
      >
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          {contact.type}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {contact.detail}
        </Typography>
      </Stack>
      {
        isHovering &&
        <Stack
          direction={'row'}
          alignItems="center"
        >
          <Box>
            <Tooltip
              title={translate('client.ClientDetail.Settings.Contact.Copy')}
              placement="top"
              TransitionComponent={Zoom}
            >
              <IconButton
                onClick={copyComment}
              >
                <ContentCopyIcon
                  sx={{
                    color: copyButton && 'secondary.main',
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
          <Box>
            <Tooltip
              title={translate('client.ClientDetail.Settings.Contact.Delete')}
              placement="top"
              TransitionComponent={Zoom}
            >
              <IconButton
                onClick={() => setIsDeleting(true)}
              >
                <DeleteIcon
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Stack>
      }
      {
        isDeleting &&
        <Dialog onClose={() => setIsDeleting(false)}>
          <DialogTitle onClose={() => setIsDeleting(false)}>
            <Translate expression='generic.ConfirmTheAction'/>
          </DialogTitle>
          <DialogContent>
            <Typography>
              <Translate expression='generic.DeleteConfirm'/>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={() => setIsDeleting(false)}>
              <Translate expression='generic.Cancel'/>
            </Button>
            <Button onClick={deleteContact}>
              <Translate expression='generic.Confirm'/>
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Stack>
  );
};

ClientContact.propTypes = {
  contact: PropTypes.object.isRequired,
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(ClientContact);
